import React, { PropsWithChildren } from "react";
import Loader from "react-spinners/PropagateLoader";
import { useThemeColors } from "../../Store/modules/theme";

export type HasLoadingProps = {
  loading: boolean;
  LoadingComponent?: any;
  boxClassName?: any;
};

export const HasLoading: React.FC<PropsWithChildren<HasLoadingProps>> = (
  props,
) => {
  const [theme] = useThemeColors();
  const { loading, children, boxClassName, LoadingComponent = Loader } = props;
  return (
    <div className={`w-full ${boxClassName ? boxClassName : ""}`}>
      {loading ? (
        <div className="flex justify-center py-5">
          <LoadingComponent size={20} color={theme["primary"]} />
        </div>
      ) : (
        children
      )}
    </div>
  );
};
